module.exports = __webpack_public_path__ + "static/media/ua_pildoras.27ff44e4.svg";